import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Recommendation.css';
import { getRecommendations } from '../api/recommendationAPI';


// כרטיס המלצה – ללא תמונה
const RecommendationCard = ({ rec, onOpen }) => {
  return (
      <div className="rec-card-border">

        {/* טקסט ההמלצה */}
        <div className="rec-card-media" >
          <div className="rec-card-text">
            {rec.text}
          </div>
        </div>

        {/* שם הממליץ */}
        <div className="rec-card-footer">
          <div className="rec-card-name">
            {rec.name}
          </div>
        </div>

      </div>
  );
};


const Recommendations = () => {
  const navigate = useNavigate();

  const [recs, setRecs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ⭐ את זה את צריכה לכתוב בקובץ recommendationAPI.js
  //    פונקציה fetch לנתיב: /api/recommendations
  const fetchRecommendations = async () => {
    setLoading(true);
    setError(null);

    try {
      const json = await getRecommendations(); // ← קריאה ל־API החדש שלך
      setRecs(json);
    } catch (e) {
      setError(e.message || 'שגיאה');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecommendations();
  }, []);

  const openItem = (rec) => {
    navigate(`/recommendation/${rec.id}`);
  };

  return (
    <div className="recs-container">
      <div className="recs-frame">
        <h2 className="page-title">ככה מספרים לנו</h2>

        {loading && <div className="recs-loading">...טוען המלצות</div>}
        {error && <div className="recs-error">אופסססס, משהו השתבש</div>}

        <div className="recs-grid">
          {recs.map(r => (
            <RecommendationCard
              key={r.id}
              rec={r}
              onOpen={openItem}
            />
          ))}
        </div>

        {!loading && !error && recs.length === 0 && (
          <div className="recs-empty">לא נמצאו המלצות.</div>
        )}
      </div>
    </div>
  );
};

export default Recommendations;